module.exports = __webpack_public_path__ + "static/headerimage-96e0ac0af380e58b216160fd481a098f.jpg";